import { getPreviousDate } from "../components/utils/dateFormate"
import apiService from "./api"

const categoryData = async (domainName,date=getPreviousDate(), limit=8,page=1, dynamicParams = {},token) => {
    
    const queryParams = new URLSearchParams({
      limit,
      pageNo: page,
      domain: domainName,
      startDate:date,
      ...dynamicParams,
    });

    const url =`/api/v1/admin/get-category-list?${queryParams.toString()}`;
    try {
        const response = await apiService.get(url, {}, token);
       return response
    } catch (error) {
        throw error;
    }
}

export const categoriesList = async (domain,start_date=getPreviousDate(), end_date=getPreviousDate(), params={}, token) => {

    const queryParams = new URLSearchParams({
        domain:domain,
        startDate:start_date,
        endDate:end_date,
        ...params,
    });
    const url =`/api/v1/admin/get-category-list?${queryParams.toString()}`;
    try {
        const response = await apiService.get(url, {}, token)
        return response.data
    } catch (error) {
        throw error;
    }

}

export default categoryData